var render = function render(){var _vm=this,_c=_vm._self._c;return _c('persona-view',{attrs:{"id":_vm.id,"dni":_vm.dni,"cuil":_vm.cuil}})
}
var staticRenderFns = []

export { render, staticRenderFns }